import { Component, OnInit } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder } from '@angular/forms';

import { ListaItem } from '../shared/models/lista-item';
import { ListaItemService } from '../shared/services/lista-item.service';
import { SesionService } from '../shared/services/sesion.service';


@Component({
  selector: 'app-administrar-listas',
  templateUrl: './administrar-listas.component.html',
  styleUrls: ['./administrar-listas.component.css']
})
export class AdministrarListasComponent implements OnInit {

  listaItems: ListaItem[] = new Array();
  codigoListaSeleccionada = '-1';
  filtroValorItem = '';
  itemSeleccionado: ListaItem = new ListaItem();
  indexSeleccionado = -1;
  modalRef: NgbModalRef;


  constructor(private listaItemService: ListaItemService, private modalService: NgbModal) { }

  ngOnInit() {
  }

  public buscarListas(cargandoModal) {
    this.modalRef = this.modalService.open(cargandoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
    let valorconsulta = '';
    if (this.filtroValorItem.length < 1) {
      valorconsulta = '-1';
    } else {
      valorconsulta = this.filtroValorItem;
    }
    this.listaItemService.listaItemsPorCodigoValor(this.codigoListaSeleccionada, valorconsulta).subscribe(
      resultado => {
        this.listaItems = resultado;
        this.modalRef.close();
      }
    );
  }

  public editarItem(item: ListaItem, editarModal) {
    this.indexSeleccionado = this.listaItems.indexOf(item);
    this.itemSeleccionado.idListaItem = this.listaItems[this.indexSeleccionado].idListaItem;
    this.itemSeleccionado.codigoItem = this.listaItems[this.indexSeleccionado].codigoItem;
    this.itemSeleccionado.indicadorHabilitado = this.listaItems[this.indexSeleccionado].indicadorHabilitado;
    this.itemSeleccionado.valorItem = this.listaItems[this.indexSeleccionado].valorItem;
    this.itemSeleccionado.lista = this.listaItems[this.indexSeleccionado].lista;
    this.modalRef = this.modalService.open(editarModal, { backdrop: 'static', size: 'lg' });
  }

  public guardarCambios(cargandoModal, resultadoModal) {
    this.modalRef.close();
    this.modalRef = this.modalService.open(cargandoModal, {backdrop: 'static', keyboard: false, size: 'lg'});
    this.listaItemService.editarListaItem(this.itemSeleccionado).subscribe(
      resultado => {
        this.modalRef.close();
        this.listaItems[this.indexSeleccionado] = resultado;
        this.modalRef.close();
        this.modalRef = this.modalService.open(resultadoModal, { size: 'lg'});
      }, error => {
        this.modalRef.close();
      }
    );
  }

}



// WEBPACK FOOTER //
// ./src/app/administrar-listas/administrar-listas.component.ts